import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import store from "./store.js"
import { Provider } from "react-redux"
import reportWebVitals from "./reportWebVitals"
import "bootstrap/dist/css/bootstrap.min.css"
import "balloon-css"

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App {...window.templateProps} />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)

reportWebVitals()
